export enum FeedbackModel {
    OFISPRO = 1,
    ICRAPRO = 2,
    EICRAPRO = 3,
}